export default __webpack_public_path__ + "static/media/metamask.7b0bea64.png";